import {
  customLocalStorage,
  customSessionStorage,
  unifiedCookieStorage,
  migrateCookieConsentToUnified,
} from '@/tool/storage'
import { getLang, getCountry } from '@/tool/utils'
import { getScheme } from '@/api'
import { fromInstalledWebAppFlag } from '@/tool/pwaEntry'

function isMobile() {
  return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)
}

// 流程：1) 先检查统一记录 2) 无则遍历各游戏、取权限最高、设统一、删各游戏 3) 再检查统一，无则由 accept.vue 拉弹窗
function hasUnifiedCookieConsent() {
  const accept = unifiedCookieStorage.getItem('acceptis')
  const acceptAll = unifiedCookieStorage.getItem('acceptAll')
  return !!(accept || acceptAll)
}

function getAcceptAll() {
  // 第一次检查：是否同意过 cookie（仅读统一，不迁移）
  if (hasUnifiedCookieConsent()) {
    const acceptAll = unifiedCookieStorage.getItem('acceptAll')
    const accept = unifiedCookieStorage.getItem('acceptis')
    if (acceptAll) return acceptAll === '1'
    if (accept) {
      unifiedCookieStorage.setItem('acceptAll', '1')
      return true
    }
  }
  // 无统一记录：遍历所有游戏储存的同意情况 → 取权限最高者 → 设置统一、删除各游戏
  migrateCookieConsentToUnified()
  // 第二次检查：再读统一记录
  const acceptAll = unifiedCookieStorage.getItem('acceptAll')
  const accept = unifiedCookieStorage.getItem('acceptis')
  if (acceptAll) return acceptAll === '1'
  if (accept) {
    unifiedCookieStorage.setItem('acceptAll', '1')
    return true
  }
  return false
}

function getAccept() {
  if (hasUnifiedCookieConsent()) {
    return !!(unifiedCookieStorage.getItem('acceptis') || unifiedCookieStorage.getItem('acceptAll'))
  }
  migrateCookieConsentToUnified()
  return !!(unifiedCookieStorage.getItem('acceptis') || unifiedCookieStorage.getItem('acceptAll'))
}

const app = {
  namespaced: true,
  state: {
    accept: getAccept(),
    acceptAll: getAcceptAll(),
    conutry: getCountry(),
    showLoading: false,
    isMobile: isMobile(),
    isCSSMobile: window.isMobile,
    isUIMobile: document.documentElement.clientWidth < 1024,
    gameId: process.env.VUE_APP_GAME_ID,

    isNoScroll: false,

    isNewWebsite: /^store/.test(location.hostname),

    // 是否收税
    isProductionTax: 1,
    productionTaxExpires: 0,

    aesKey: '',
    encryptedAesKey: '',

    isShowCaptureModal: customLocalStorage.getItem('lcaptcha') ? false : true,

    isSendCode: false,

    seoLang: JSON.parse(process.env.VUE_APP_SEO_LANG || '{}'),

    gameScheme: {
      scheme: '',
      universal_link: '',
    },
    /** 是否从 PWA / 桌面快捷方式 / 主屏幕已安装应用进入（首屏固定，与 window.__CG_STORE_FROM_INSTALLED_WEB_APP__ 一致） */
    fromInstalledWebApp: fromInstalledWebAppFlag,
    /** 浏览器是否触发过可被拦截的 beforeinstallprompt（与 head/webapp 本地状态同步） */
    isInstallPromptSupported: false,
    /** 当前选中礼包 customization_flag（点击礼包时写入，下单 buildOrderPayload 读取） */
    customizationFlag: 0,
  },

  mutations: {
    SET_ACCEPT: (state, accept) => {
      state.accept = accept
    },
    SET_COUNTRY: (state, conutry) => {
      state.conutry = conutry
    },
    SET_SHOWLOADING: (state, showLoading) => {
      state.showLoading = showLoading
    },
    SET_IS_NO_SCROLL: (state, isNoScroll) => {
      state.isNoScroll = isNoScroll
    },
    SET_ACCEPT_ALL: (state, acceptAll) => {
      state.acceptAll = acceptAll
      // 获取当前语言
      const lang = getLang()
      if (!acceptAll) {
        customSessionStorage.setItem('vipMallLangCode', lang)
        customLocalStorage.removeItem('vipMallLangCode')
        customLocalStorage.removeItem('postcode_US')
        customLocalStorage.removeItem('postcode_CA')
      } else {
        customLocalStorage.setItem('vipMallLangCode', lang)
      }
      unifiedCookieStorage.setItem('acceptAll', acceptAll ? '1' : '0')
    },
    SET_IS_MOBILE: (state) => {
      state.isCSSMobile = window.isMobile
      state.isUIMobile = document.documentElement.clientWidth < 1024
    },
    SET_IS_PRODUCTION_TAX: (state, isProductionTax) => {
      state.isProductionTax = isProductionTax
    },
    SET_PRODUCTION_TAX_EXPIRES: (state, productionTaxExpires) => {
      state.productionTaxExpires = productionTaxExpires
    },
    SET_AES_KEY: (state, aesKey) => {
      state.aesKey = aesKey
    },
    SET_ENCRYPTED_AES_KEY: (state, encryptedAesKey) => {
      state.encryptedAesKey = encryptedAesKey
    },
    SET_IS_SHOW_CAPTURE_MODAL: (state) => {
      customLocalStorage.setItem('lcaptcha', '1')
      state.isShowCaptureModal = false
    },
    SET_IS_SEND_CODE: (state, isSendCode) => {
      state.isSendCode = isSendCode
    },
    SET_GAME_SCHEME: (state, gameScheme) => {
      state.gameScheme = gameScheme
    },
    SET_IS_INSTALL_PROMPT_SUPPORTED: (state, supported) => {
      state.isInstallPromptSupported = !!supported
    },
    SET_CUSTOMIZATION_FLAG: (state, customizationFlag) => {
      state.customizationFlag = Number(customizationFlag) || 0
    },
  },

  actions: {
    setShowLoading({ commit }, s) {
      commit('SET_SHOWLOADING', s)
    },
    FETCH_GAME_SCHEME({ commit, state }, game_id) {
      if (state.isMobile || window.document.documentElement.clientWidth <= 1024) {
        getScheme({ game_id }).then((res) => {
          console.log('getGameScheme', res)
          if (res && res.data.code == 1) {
            commit('SET_GAME_SCHEME', { ...(res.data.data || {}) })
          }
        })
      }
    },
  },
}

export default app
